<template>
  <el-card :style="'border-left: 6px ridge ' + currentCategory().color">
    {{ currentCategory().description || '相关话题（已关闭的话题不在搜索范围）'}}
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentCategory"])
  }
};
</script>
